import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { UpsertUserRequest } from './types/upsert-user-request.type';

/**
 * Creates or updates a user.
 *
 * @param instance - Ky HTTP instance from the application store.
 * @param body - The user payload (omit `uid` to create).
 * @returns OperationResultWithData wrapping the id/uid tuple of the upserted user.
 */
export const upsertUser = async (instance: KyInstance, body: UpsertUserRequest) => {
  try {
    return await instance
      .post<OperationResultWithData<[null | number, null | string]>>(Uri.users.base, {
        json: body,
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
